import { render, staticRenderFns } from "./ShowcaseSettings.vue?vue&type=template&id=2c577332&scoped=true"
import script from "./ShowcaseSettings.vue?vue&type=script&lang=js"
export * from "./ShowcaseSettings.vue?vue&type=script&lang=js"
import style0 from "./ShowcaseSettings.vue?vue&type=style&index=0&id=2c577332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c577332",
  null
  
)

export default component.exports